interface DataTableEmptyStateProps {
  message?: string;
}

export function DataTableEmptyState({ message = 'No data to display.' }: DataTableEmptyStateProps) {
  return <div className="px-3 py-8 text-center text-sm text-muted-foreground">{message}</div>;
}
